import Vue from 'vue'
import Router from 'vue-router'

const AuthPage = () => import('@/pages/auth/auth.vue')
const WelcomeScreen = () => import('@/pages/welcome-screen/welcome-screen.vue')
const ShiftReport = () => import('@/pages/shift-report/shift-report.vue')
const MainPage = () => import('@/pages/main/main.vue')
const CouriersPage = () => import('@/pages/couriers/couriers.vue')
const OrderDetail = () => import('@/pages/order-detail/order-detail.vue')
const CourierShifts = () => import('@/pages/courier-shifts/courier-shifts.vue')
const System = () => import('@/pages/system/system.vue')
const RegionOrders = () => import('@/pages/region-orders/region-orders.vue')
const DashboardManufactures = () => import('@/pages/dashboard-manufactures/dashboard-manufactures.vue')
const ProductionSummary = () => import('@/pages/production-summary/production-summary.vue')
const CollectOrders = () => import('@/pages/collect-orders/collect-orders.vue')
const GlobalSettings = () => import('@/pages/global-settings/global-settings.vue')

Vue.use(Router)

export const routes = [
  {
    path: '/',
    redirect: '/main'
  },
  {
    path: '/auth',
    name: 'auth',
    component: AuthPage,
  },
  {
    path: '/welcome-screen',
    name: 'welcome-screen',
    component: WelcomeScreen
  },
  {
    path: '/shift-report/:id',
    name: 'shift-report',
    component: ShiftReport
  },
  {
    path: '/order/:id',
    name: 'order-detail',
    component: OrderDetail
  },
  {
    path: '/courier-shifts',
    name: 'courier-shifts',
    component: CourierShifts
  },
  {
    path: '/production-summary',
    name: 'production-summary',
    component: ProductionSummary,
    title: 'Регионы',
    icon: 'regions',
    inMenu: true
  },
  {
    path: '/dashboard-manufactures',
    name: 'dashboard-manufactures',
    component: DashboardManufactures,
    title: 'Производства',
    icon: 'manufactures',
    inMenu: true
  },
  {
    path: '/region-orders',
    name: 'region-orders',
    component: RegionOrders,
    title: 'Мониторинг',
    icon: 'monitoring',
    inMenu: true
  },
  {
    path: '/main',
    name: 'main',
    component: MainPage,
    title: 'Заказы',
    icon: 'order',
    inMenu: true
  },

  {
    path: '/collect-orders',
    name: 'collect-orders',
    component: CollectOrders,
    title: 'Сборка заказов',
    icon: 'order-collect',
    inMenu: true
  },

  {
    path: '/couriers',
    name: 'couriers',
    component: CouriersPage,
    title: 'Курьеры',
    icon: 'courier-menu',
    inMenu: true
  },
  {
    path: '/system',
    name: 'system',
    component: System,
    title: 'Системная страница',
    icon: 'settings',
    inMenu: true
  },
  {
    path: '/global-settings',
    name: 'global-settings',
    component: GlobalSettings,
    title: 'Массовые настройки',
    icon: 'global-settings',
    inMenu: true
  },

  {
    path: "*",
    redirect: '/main'
  }
]

const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes
})

export default router